import { useState } from 'react'
import React, { ChangeEvent, useCallback } from 'react'

/**
 * To be used on input elements like:
 * const bound = useInput()
 * <input {...bound} />
 *
 * Can be update directly like: bound.onChange('new value')
 */

export const useInput = (initialState: string = '') => {
  const [state, setState] = useState(initialState)

  // callbacks keeps the same function and avoid re-renders.
  const update = useCallback(
    (e: ChangeEvent<HTMLInputElement> | any) => setState(e?.target?.value ?? e),
    []
  )

  return { value: state, onChange: update }
}
